
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/subscribe-shopify",
      function () {
        return require("private-next-pages/[lang]/subscribe-shopify.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/subscribe-shopify"])
      });
    }
  